module.exports = __webpack_public_path__ + "static/media/course-2.50943477.png";